import { FormChoiceResponse, FormChoiceResponseType } from 'types';

// Normalize legacy saved answers at the form boundary. Typed responses, including
// Other text, stay untouched; malformed data remains visible to validation.
export const normalizeChoiceResponseValue = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map((item) =>
      typeof item === 'string'
        ? { value: item, type: FormChoiceResponseType.OPTION }
        : item
    );
  }
  if (typeof value === 'string') {
    return value === '' ? null : { value, type: FormChoiceResponseType.OPTION };
  }
  return value;
};

export const isFormChoiceResponse = (
  value: unknown
): value is FormChoiceResponse =>
  Boolean(
    value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.values(FormChoiceResponseType).includes(
      (value as FormChoiceResponse).type
    ) &&
    typeof (value as FormChoiceResponse).value === 'string'
  );
